import { render, staticRenderFns } from "./LabWorkOrderView.vue?vue&type=template&id=40ecef8b&scoped=true"
import script from "./LabWorkOrderView.vue?vue&type=script&lang=js"
export * from "./LabWorkOrderView.vue?vue&type=script&lang=js"
import style0 from "./LabWorkOrderView.vue?vue&type=style&index=0&id=40ecef8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ecef8b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAutocomplete,VCol,VRow,VSelect,VSpacer,VTextField,VTextarea})
